const businessSettings = {
  title: "Impostazioni azienda",
  backLabel: "Impostazioni",
  tabs: {
    business: "Azienda",
    team: "Team",
    sso: "SSO",
    referral: "Programma referral"
  },
  businessDetails: {
    title: "Dettagli azienda",
    subtitle: "I dettagli dell'azienda saranno modificati dopo la moderazione",
    editButton: "Modifica dettagli azienda",
    labels: {
      businessName: "Ragione sociale",
      businessEmail: "Email aziendale",
      phone: "Telefono",
      accountId: "ID account",
      merchantId: "ID venditore",
      taxNumberType: "Tipo numero fiscale",
      taxNumber: "Numero fiscale",
      country: "Paese",
      city: "Città",
      streetAddress: "Indirizzo",
      houseNumber: "Numero civico",
      apartment: "Appartamento, interno, ecc.",
      postcode: "CAP",
      reportingPerson: "Persona responsabile delle dichiarazioni",
      registrationCode: "Codice di registrazione",
      address: "Indirizzo"
    },
    form: {
      cancel: "Annulla",
      save: "Salva",
      saving: "Salvataggio...",
      businessNamePlaceholder: "Ragione sociale",
      businessNameHint: "Per cambiare la ragione sociale dovrai fornire una copia del documento che attesta il nuovo nome, ad es.:",
      businessNameHintList1: "Estratto dal registro delle imprese",
      businessNameHintList2: "Dichiarazione di conformità",
      businessNameHintList3: "Certificato di registrazione aggiornato ecc. secondo la normativa vigente del paese di incorporazione",
      chooseFile: "Scegli file",
      chooseFileHint: "Scegli file *jpg, *jpeg, *png, *pdf da caricare",
      selectTaxNumberType: "Seleziona tipo numero fiscale",
      optional: "Opzionale",
      removeFile: "Rimuovi"
    },
    errors: {
      saveFailed: "Salvataggio informazioni azienda fallito",
      anErrorOccurred: "Si è verificato un errore"
    }
  },
  sensitiveActions: {
    title: "Azioni sensibili",
    subtitle: "Controlli a livello proprietario per gestione account e fatturazione",
    showActions: "Mostra azioni sensibili",
    hideActions: "Nascondi azioni sensibili",
    aiOptOut: "Non utilizzare le mie transazioni per machine learning e intelligenza artificiale",
    cancelSubscription: "Annulla abbonamento",
    deleteAccount: "Elimina account"
  },
  advancedActions: {
    title: "Azioni avanzate",
    subtitle: "Controlli a livello proprietario per gestione account e fatturazione",
    showActions: "Mostra azioni avanzate",
    hideActions: "Nascondi azioni avanzate",
    helpImproveAI: {
      title: "Aiuta a migliorare l'AI",
      description: "Usa le mie transazioni per migliorare machine learning e intelligenza artificiale"
    },
    cancelSubscription: {
      title: "Annulla abbonamento",
      description: "Interrompi l'abbonamento. Conserverai l'accesso fino alla fine del periodo di fatturazione"
    },
    deleteAccount: {
      title: "Elimina account",
      description: "Elimina definitivamente il tuo account e tutti i dati associati. Questa azione non può essere annullata"
    }
  },
  team: {
    searchPlaceholder: "Cerca",
    newMember: "Nuovo membro",
    addNewMember: "Aggiungi nuovo membro",
    roleItems: {
      owner: {
        title: "Owner",
        description: "Full access to company settings, users, billing, and account deletion"
      },
      admin: {
        title: "Admin",
        description: "Full access to company settings, users, and applications"
      },
      finance: {
        title: "Finance",
        description: "Access to billing, payments, invoices, and financial information"
      },
      developer: {
        title: "Developer",
        description: "Access to integrations, APIs, and technical settings"
      },
      preparer: {
        title: "Preparer",
        description: "Can prepare and manage data for filings and submissions"
      },
      user: {
        title: "User",
        description: "Standard access to assigned applications and features"
      }
    },
    appItems: {
      ltax: {
        title: "L'Tax",
        description: "Tax registration, reporting, and compliance"
      },
      lepr: {
        title: "L'EPR",
        description: "EPR registration, reporting, and compliance"
      },
      linvoice: {
        title: "L'Invoice",
        description: "Create, manage, and process invoices"
      },
      lauthorize: {
        title: "L'Authorize",
        description: "Product compliance and authorized representative services"
      },
      lmarketplace: {
        title: "L'Marketplace",
        description: "Manage marketplace compliance and related services"
      }
    },
    tableHeaders: {
      name: "NOME",
      role: "RUOLO",
      apps: "APP",
      actions: "AZIONI"
    },
    you: "Tu",
    invitationPending: "Invito in sospeso",
    allCountries: "Tutti i paesi",
    showMore: "Mostra altro",
    showLess: "Mostra meno",
    noResults: {
      title: "Nessun risultato",
      description: "La ricerca \"{{search}}\" non ha trovato nessun membro. Riprova o aggiungi un nuovo membro.",
      clearSearch: "Cancella ricerca"
    },
    actions: {
      view: "Visualizza",
      manage: "Gestisci",
      removeMember: "Rimuovi membro"
    },
    messages: {
      inviteSent: "Invito inviato con successo",
      memberUpdated: "Membro aggiornato con successo",
      failedToSendInvite: "Invio invito fallito",
      failedToUpdateMember: "Aggiornamento membro fallito",
      failedToRemoveMember: "Rimozione membro fallita",
      anErrorOccurred: "Si è verificato un errore"
    },
    modals: {
      addMember: {
        title: "Aggiungi nuovo membro",
        emailLabel: "Inserisci l'indirizzo email del membro del team",
        emailPlaceholder: "josh@example.com",
        role: "Ruolo",
        apps: "App",
        selectCountries: "Seleziona paesi",
        stateLabel: "Stato",
        selectStates: "Seleziona stati",
        taxAccessHint: "Limita l'IVA ai paesi selezionati e la Sales Tax agli stati selezionati. Lascia Tutti i paesi per accesso senza restrizioni.",
        eprAccessHint: "Limita l'accesso ai paesi selezionati. Lascia Tutti i paesi per accesso senza restrizioni.",
        cancel: "Annulla",
        sendInvites: "Invia inviti",
        loading: "Caricamento..."
      },
      editMember: {
        cancel: "Annulla",
        saveChanges: "Salva modifiche",
        saving: "Salvataggio..."
      },
      viewMember: {
        role: "Ruolo",
        phoneNumber: "Numero di telefono",
        apps: "App",
        twoStepAuth: "Autenticazione a due fattori",
        turnedOn: "Attivata",
        turnedOff: "Disattivata",
        removeFromTeam: "Rimuovi dal team",
        manage: "Gestisci"
      },
      removeMember: {
        title: "Rimuovi dal team",
        description: "Questo utente perderà l'accesso a tutte le app e i dati del team. Potrai aggiungerlo di nuovo in seguito se necessario",
        cancel: "Annulla",
        remove: "Rimuovi"
      }
    },
    validation: {
      emailRequired: "L'email è obbligatoria",
      emailInvalid: "Inserisci un indirizzo email valido"
    }
  },
  deleteAccount: {
    modals: {
      whatYouNeedToKnow: {
        title: "Cosa devi sapere",
        paragraph1: "Se scegli di eliminare il tuo account Lappa, perderai immediatamente l'accesso. I tuoi dati saranno inoltre programmati per l'eliminazione permanente dopo trenta giorni e non potranno essere recuperati dopo quella data. Secondo i nostri termini di servizio, non possiamo offrire un rimborso pro-rata per eventuali periodi rimanenti di abbonamento non utilizzato.",
        paragraph2: "In alternativa, se desideri smettere di pagare Lappa per ora ma pensi di poterlo usare di nuovo in futuro, puoi annullare l'abbonamento. In tal caso perderai l'accesso immediatamente ma conserveremo i dati del tuo account in modo sicuro per un anno prima di eliminarli automaticamente. Questa opzione ti consentirebbe di riattivare l'account in qualsiasi momento entro un anno dalla data di annullamento.",
        paragraph3: "Nota che avrai bisogno dell'accesso Proprietario al tuo account Lappa per poter eliminare l'account.",
        agreeLabel: "Ho letto quanto sopra",
        termsAndConditions: "Termini e condizioni",
        agreeSuffix: "e acconsento a eliminare il mio account Lappa",
        cancel: "Annulla",
        delete: "Elimina"
      },
      confirmPassword: {
        title: "Conferma la tua password",
        verifyTitle: "Verifica di aver compreso quanto segue:",
        verify1: "Tutte le informazioni del tuo account saranno cancellate definitivamente.",
        verify2: "Tutte le transazioni, dichiarazioni fiscali, file, allegati e documenti caricati saranno cancellati definitivamente.",
        verify3: "Eventuali mandati di addebito diretto creati tramite Lappa saranno cancellati definitivamente.",
        passwordLabel: "Conferma la tua password",
        passwordPlaceholder: "Inserisci la tua password",
        cancel: "Annulla",
        delete: "Elimina",
        passwordRequired: "La password è obbligatoria",
        failedToDelete: "Eliminazione account fallita. Riprova."
      }
    }
  },
  cancelSubscription: {
    modals: {
      selectSubscription: {
        title: "Seleziona l'abbonamento da annullare",
        cancel: "Annulla",
        continue: "Continua"
      },
      reasons: {
        title: "Questi motivi ci aiutano a capire perché i clienti scelgono di annullare e consentono di migliorare il servizio",
        tooExpensive: "Troppo costoso",
        tooExpensiveSubtitle: "Il costo del servizio sembra troppo alto per la tua attività",
        switchedService: "Passato a un altro servizio",
        switchedServiceSubtitle: "Hai scelto un'altra società o piattaforma per la compliance fiscale",
        missingFeatures: "Funzioni necessarie mancanti",
        missingFeaturesSubtitle: "Il servizio non ha le funzioni o gli strumenti di cui hai bisogno",
        businessChanges: "Cambiamenti nella struttura aziendale",
        businessChangesSubtitle: "La tua attività ha modificato il piano o la struttura fiscale in modo che non richieda più questi servizi",
        poorQuality: "Scarsa qualità del servizio",
        poorQualitySubtitle: "Eri insoddisfatto della qualità del supporto o dei servizi",
        rarelyUsed: "Poco utilizzato",
        rarelyUsedSubtitle: "Il servizio non è stato usato quanto previsto",
        other: "Altro",
        otherPlaceholder: "Scrivi il motivo",
        back: "Indietro",
        continue: "Continua"
      },
      confirm: {
        title: "Conferma annullamento abbonamento",
        descriptionWithDate: "Il tuo abbonamento terminerà il {{date}}. Dopo tale data perderai l'accesso al calcolo e alla dichiarazione fiscale.",
        descriptionWithoutDate: "Il tuo abbonamento terminerà dopo il periodo di fatturazione corrente. Dopo perderai l'accesso al calcolo e alla dichiarazione fiscale.",
        refundTitle: "Informazioni sul rimborso",
        refundText: "Non riceverai un rimborso trattandosi di un abbonamento prepagato. I prodotti e servizi LAPPA resteranno disponibili fino alla scadenza del piano. Consulta i nostri",
        termsAndConditions: "Termini e condizioni",
        keepSubscription: "Mantieni abbonamento",
        cancelSubscription: "Annulla abbonamento",
        failedToCancel: "Annullamento abbonamento fallito. Riprova."
      }
    }
  },
  sso: {
    title: "I tuoi domini SSO",
    description: "Gestisci le autorizzazioni Single Sign-On (SSO) per i membri del tuo team. Come proprietario, puoi assegnare diritti di accesso specifici a ogni membro della tua azienda, assicurando che tutti abbiano le autorizzazioni necessarie per il loro ruolo.",
    addDomain: "Aggiungi dominio SSO",
    loading: "Caricamento...",
    verified: "Verificato",
    notVerified: "Non verificato",
    tableHeaders: {
      domain: "DOMINIO",
      verificationStatus: "STATO VERIFICA",
      added: "AGGIUNTO",
      ssoStatus: "STATO SSO",
      actions: "AZIONI",
    },
    actions: {
      ssoSettings: "Impostazioni SSO",
      deleteDomain: "Elimina dominio",
    },
    emptyState: {
      title: "Nessun risultato trovato",
      description: "Attualmente non hai domini SSO",
    },
    modals: {
      addDomain: {
        title: "Aggiungi nuovo dominio SSO",
        editTitle: "Impostazioni SSO",
        cancel: "Annulla",
        back: "Indietro",
        continue: "Continua",
        step1: {
          stepLabel: "Passo 1/6",
          helperText: "Aggiungi il dominio email della tua organizzazione",
          domainLabel: "Dominio",
          domainPlaceholder: "sso.company.example.com",
        },
        step2: {
          stepLabel: "Passo 2/6",
          helperText: "Vai al tuo provider DNS e aggiungi un record con i seguenti dettagli. Potrebbero essere necessarie fino a 24 ore per completare la verifica del dominio.",
          domain: "Dominio",
          name: "Nome",
          record: "Record",
          dnsCode: "Codice DNS",
          copyCode: "Copia codice",
          copied: "Copiato",
          error: "Il dominio non può essere verificato perché il dominio non è registrato",
        },
        step3: {
          stepLabel: "Passo 3/6",
          helperText: "Fornisci il record DNS per verificare il tuo dominio. Le seguenti informazioni possono essere recuperate dal tuo provider DNS",
          identityProviderUrlLabel: "URL del provider di identità",
          identityProviderUrlPlaceholder: "https://sso.example.com/saml/login",
          issuerIdLabel: "ID emittente",
          issuerIdPlaceholder: "example-sso-idp",
          identityProviderCertificateLabel: "Certificato del provider di identità",
          identityProviderCertificatePlaceholder: "-----BEGIN CERTIFICATE-----\n...\n-----END CERTIFICATE-----",
        },
        step4: {
          stepLabel: "Passo 4/6",
          helperText: "Configura il tuo provider di identità con le seguenti impostazioni",
          loading: "Caricamento dettagli del service provider...",
          copied: "{{field}} copiato negli appunti",
          copyButton: "Copia",
          copyToClipboard: "Copia negli appunti",
          clickToCopy: "Clicca per copiare",
        },
        step5: {
          stepLabel: "Passo 5/6",
          helperText: "Fornisci l'indirizzo email dell'utente per il quale desideri testare la configurazione. È importante testare la configurazione SSO prima di salvarla per evitare errori e prevenire il blocco degli utenti.",
          emailLabel: "Email",
          emailPlaceholder: "email@example.com",
        },
        step6: {
          stepLabel: "Passo 6/6",
          helperText: "Validazione completata con successo",
          validationFailedSummary: "La validazione SSO non è stata completata correttamente.",
          failedGenericError:
            "Impossibile completare la validazione SSO. Riprova o contatta l’assistenza.",
          failedValidating: "Verifica della configurazione…",
          processing: "Elaborazione... Completa l'autenticazione nella finestra aperta.",
          waiting: "In attesa del completamento dell'autenticazione...",
          processingTimeoutMessage:
            "Il server non ha risposto entro il tempo previsto. Controlla i dettagli della configurazione SSO e riprova.",
          authPollingTimeout:
            "Impossibile confermare l’autenticazione SSO in tempo. Riprova o contatta l’assistenza.",
          validationSteps: {
            samlRequestExpired: "Verifica che la richiesta SAML non sia scaduta",
            validSamlResponse: "Ricevi una risposta SAML valida",
            validIssuerId: "Verifica ID emittente",
            validIdpUrl: "Verifica URL del provider di identità",
            validCertificate: "Verifica certificato del provider di identità",
            userAccessVerified: "Verifica accesso utente al dominio",
            roleAssertionReceived: "Ricevi asserzione ruolo nella risposta SAML",
            roleAssignmentsValid: "Verifica assegnazioni ruolo",
          },
        },
        saveConfiguration: "Salva configurazione",
        loading: "Caricamento...",
        stepFlowAriaLabel: "Passaggi di validazione SSO",
      },
      deleteDomain: {
        title: "Elimina dominio SSO",
        description: "Sei sicuro di voler eliminare il dominio SSO {{domain}}?",
        warning: "Questa azione è permanente",
        cancel: "Annulla",
        delete: "Elimina",
        error: {
          noDomainId: "ID dominio mancante",
          failed: "Impossibile eliminare il dominio SSO",
        },
      },
      deactivateConfiguredDomain: {
        title: "Disattiva SSO",
        description:
          "Stai per disattivare l'SSO per {{domain}}. I membri del team non potranno usare questa configurazione SSO finché non la configurerai di nuovo.",
        warning: "Il dominio non viene eliminato. Puoi gestire di nuovo l'SSO dalle impostazioni quando necessario.",
        cancel: "Annulla",
        deactivate: "Disattiva",
        error: {
          noConfigId: "ID configurazione SSO mancante",
          failed: "Impossibile disattivare l'SSO. Riprova.",
        },
      },
    },
  },
  referralProgram: {
    header: {
      title: "Ricevi 150 € per ogni azienda che consigli",
      subtitle: "Loro ricevono 300 €, tu ricevi 150 € — ci guadagnano tutti",
      howItWorks: "Come funziona?",
    },
    linkSection: {
      shareLink: "Condividi il tuo link di referral personale",
      copyLink: "Copia link",
      or: "o",
      inviteByEmail: "Invita via email",
      emailPlaceholder: "Inserisci l’indirizzo email",
      sendInvite: "Invia invito",
      inviteSuccess: "Invito referral inviato",
      inviteErrorFallback: "Impossibile inviare l’invito referral",
    },
    rewardsSection: {
      title: "Le tue ricompense",
      subtitle: "Puoi usarle per pagare i servizi LAPPA",
      balance: "Saldo",
      clientsInvited: "Clienti invitati",
      totalEarned: "Ricompense totali guadagnate",
    },
    referralsSection: {
      columns: {
        referrals: "Referral",
        earned: "Guadagnato",
      },
      empty: {
        title: "Nessun risultato trovato",
        subtitle: "Al momento non hai referral",
      },
    },
    howItWorksModal: {
      title: "Come funziona?",
      subtitle: "Invita un’azienda e ricevi una ricompensa quando diventa cliente",
      close: "Chiudi",
      copyInviteLink: "Copia link di invito",
      learnMore: "Scopri di più",
      hideDetails: "Nascondi dettagli",
      detailsTitle: "Dettagli importanti",
      detailsItems: {
        rewardDelay: "Le ricompense vengono erogate dopo 60 giorni di abbonamento attivo",
        creditsApply: "I crediti valgono solo sulle quote di abbonamento",
        creditsNoCombine: "I crediti non sono cumulabili con altri sconti",
        creditsExpiry: "I crediti scadono dopo 12 mesi",
      },
      steps: {
        inviteCompany: {
          title: "Invita un’azienda",
          description:
            "Condividi il link di referral o invia un invito via email direttamente dalla piattaforma",
        },
        signUp: {
          title: "Si iscrivono",
          description: "Il referral attiva un abbonamento a pagamento",
        },
        becomeCustomer: {
          title: "Diventano clienti paganti",
          description: "L’azienda si registra e inizia a usare la piattaforma",
        },
        getRewarded: {
          title: "Ricevi la ricompensa",
          description: "Dopo 60 giorni di abbonamento attivo:",
          youGetLabel: "Tu ricevi",
          youGetAmount: "150 €",
          theyGetLabel: "Loro ricevono",
          theyGetAmount: "300 €",
          creditsSuffix: "in crediti",
        },
      },
    },
  },
  errors: {
    wrongCode: "Codice errato. Riprova.",
    invalidVerificationCode: "Codice di verifica non valido. Riprova."
  }
};

export default businessSettings;
